
export enum PenUsbMode {
  DISK = "disk",
  BULK = "bulk",
}


